import { useContext } from "react"
import CoreContext from "../contexts/coreContext"

export function useCore() {
  const context = useContext(CoreContext)
  return context
}